import React from 'react';
import { FaRobot, FaSatellite, FaBolt, FaWrench, FaCheckCircle, FaChartBar } from 'react-icons/fa';
import './Sagemcom.css';

function Sagemcom() {
  return (
    <div className="sagemcom-page">
      <div className="page-header">
        <h1>Sagemcom Project</h1>
        <p>Manage and monitor your Sagemcom project activities</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <FaRobot className="stat-icon" />
          <div className="stat-content">
            <h3>Active Devices</h3>
            <p className="stat-number">156</p>
            <span className="stat-change positive">+8%</span>
          </div>
        </div>
        
        <div className="stat-card">
          <FaSatellite className="stat-icon" />
          <div className="stat-content">
            <h3>Network Status</h3>
            <p className="stat-number">98.5%</p>
            <span className="stat-change positive">+2%</span>
          </div>
        </div>
        
        <div className="stat-card">
          <FaBolt className="stat-icon" />
          <div className="stat-content">
            <h3>Performance</h3>
            <p className="stat-number">Excellent</p>
            <span className="stat-change positive">+5%</span>
          </div>
        </div>
        
        <div className="stat-card">
          <FaWrench className="stat-icon" />
          <div className="stat-content">
            <h3>Maintenance</h3>
            <p className="stat-number">3 Pending</p>
            <span className="stat-change neutral">--</span>
          </div>
        </div>
      </div>

      <div className="project-details">
        <div className="detail-section">
          <h3>Project Overview</h3>
          <div className="overview-content">
            <div className="info-row">
              <span className="info-label">Project ID:</span>
              <span className="info-value">SGM-2024-001</span>
            </div>
            <div className="info-row">
              <span className="info-label">Start Date:</span>
              <span className="info-value">January 15, 2024</span>
            </div>
            <div className="info-row">
              <span className="info-label">Status:</span>
              <span className="info-value status-active">Active</span>
            </div>
            <div className="info-row">
              <span className="info-label">Team Members:</span>
              <span className="info-value">8 Members</span>
            </div>
          </div>
        </div>

        <div className="detail-section">
          <h3>Recent Updates</h3>
          <div className="updates-list">
            <div className="update-item">
              <FaCheckCircle className="update-icon" />
              <div className="update-content">
                <p>Device configuration updated successfully</p>
                <span>Today at 10:30 AM</span>
              </div>
            </div>
            <div className="update-item">
              <FaWrench className="update-icon" />
              <div className="update-content">
                <p>Scheduled maintenance completed</p>
                <span>Yesterday at 3:45 PM</span>
              </div>
            </div>
            <div className="update-item">
              <FaChartBar className="update-icon" />
              <div className="update-content">
                <p>Performance report generated</p>
                <span>2 days ago</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tasks-section">
        <h3>Active Tasks</h3>
        <div className="tasks-list">
          <div className="task-item">
            <input type="checkbox" />
            <span className="task-text">Configure new device batch</span>
            <span className="task-priority high">High Priority</span>
          </div>
          <div className="task-item">
            <input type="checkbox" />
            <span className="task-text">Update firmware on legacy devices</span>
            <span className="task-priority medium">Medium Priority</span>
          </div>
          <div className="task-item">
            <input type="checkbox" checked />
            <span className="task-text completed">Review network performance metrics</span>
            <span className="task-priority low">Low Priority</span>
          </div>
          <div className="task-item">
            <input type="checkbox" />
            <span className="task-text">Prepare monthly status report</span>
            <span className="task-priority medium">Medium Priority</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sagemcom;

